import styled from 'styled-components'
import { ERROR } from '../constants/colours'

export const ErrorWrapper = styled.label`
  padding: 1em;
  color: ${ERROR};
  font-size: 15px;
`
